import { CREATE_MODULE, GET_MODULE, MODULE_ERROR, ROLE_MODULES } from "../types";

const initialState = {
  response: null,
  detail: false,
  create: false,
};
export default function modulesReducer(state = initialState, action) {
  switch (action.type) {
    case ROLE_MODULES:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET_MODULE:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case CREATE_MODULE:
      return {
        ...state,
        create: true,
        detail: false,
        response: action.payload,
      };
    case MODULE_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
